import React from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { LayerTree, ParentLayer } from '../../geo-info/types/map-layer';
import { useQuery } from '../../../hooks/use-query';
import { Icons } from '../../../components/icons/icons';

export const Parents = (): JSX.Element => {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const configId = params.configId as string;
  const layerId = searchParams.get('selectedLayerId') || params.layerId as string;
  const layerTree = useQuery<LayerTree>({ path: `/map-layers/tree/${layerId}?configurationId=${configId}`, options: { keepPreviousData: true } });

  const clickHandler = (parentLayer: ParentLayer): void => {
    navigate(
      `/configurations/${params.configId as string}/contents/${parentLayer.parentLayerId}/parents?selectedLayerId=${parentLayer.parentLayerId}`
    );
  };

  return <div>
    {layerTree.data?.parents.map(item => {
      return <div key={item.childLayerId} className="d-flex align-items-center pointer" onClick={(): void => clickHandler(item)}>
        <span className="layer-icon-wrapper me-2 d-flex"><Icons.Folder /></span>
        <span>{item.name}</span>
      </div>;
    })}
  </div>;
};
